import React from 'react';
import { motion } from 'framer-motion';
import { CreditCard, Hash, Mail, FileCheck } from 'lucide-react';

const HowItWorks = () => {
  const steps = [
    {
      icon: CreditCard,
      title: 'Make Payment',
      description: 'Securely pay for your CARFAX report using our encrypted payment system'
    },
    {
      icon: Hash,
      title: 'Enter VIN',
      description: 'Provide the 17-character Vehicle Identification Number after payment'
    },
    {
      icon: Mail,
      title: 'Add Email',
      description: 'Enter your email address where you want the report delivered'
    },
    {
      icon: FileCheck,
      title: 'Receive Report',
      description: 'Get your comprehensive CARFAX report in your inbox within minutes'
    }
  ];

  return (
    <section id="how-it-works" className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <h2 className="text-4xl font-bold text-[#0A1929] mb-4">How It Works</h2>
          <p className="text-xl text-gray-600">Get your vehicle history report in 4 simple steps</p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((step, index) => (
            <motion.div
              key={step.title}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="relative"
            >
              <div className="text-center">
                <div className="relative inline-block mb-6">
                  <div className="absolute inset-0 bg-[#FF6B35] rounded-full blur-lg opacity-30"></div>
                  <div className="relative bg-[#0A1929] w-20 h-20 rounded-full flex items-center justify-center">
                    <step.icon className="text-[#FF6B35]" size={36} />
                  </div>
                  <div className="absolute -top-2 -right-2 bg-[#FF6B35] text-white w-8 h-8 rounded-full flex items-center justify-center font-bold text-sm">
                    {index + 1}
                  </div>
                </div>
                <h3 className="text-xl font-bold text-[#0A1929] mb-3">{step.title}</h3>
                <p className="text-gray-600">{step.description}</p>
              </div>
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-10 left-full w-full h-0.5 bg-gradient-to-r from-[#FF6B35] to-transparent -ml-4"></div>
              )}
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;